import React from 'react';
import CarePlanComponent from './carePlan/CarePlanComponent';

const UserProfile = () => {
  return (
    <div className="container mx-auto p-4">
      <h1 className="text-3xl font-bold mb-6 text-center">User Profile</h1>
      <CarePlanComponent />
    </div>
  );
};

export default UserProfile;
